import { htmlToText } from '@elfsight/lib-utils';

const ELLIPSIS = '...';

export const truncateText = (text: string, maxLength = 100) => {
  const sanitizedText = htmlToText(text);
  if (sanitizedText.length <= maxLength) {
    return sanitizedText;
  }

  const lastSpaceIndex = sanitizedText.lastIndexOf(
    ' ',
    maxLength - ELLIPSIS.length
  );
  const truncatedText = sanitizedText.substring(0, lastSpaceIndex);

  return `${truncatedText}${ELLIPSIS}`;
};
